var _path, _g, _g2, _g3, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 86,
    viewBox: "0 0 90 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_305_737",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.8092 39.9842H9.8039L0.773912 16.904C0.0747024 15.0052 -0.155528 12.9656 0.102822 10.9588C0.361172 8.95189 1.10045 7.03709 2.25777 5.37736C3.41509 3.71759 4.95619 2.36192 6.74999 1.42568C8.5438 0.48945 10.5372 0.00035 12.5606 0H81.0171C82.5432 0.00313 84.039 0.426 85.3408 1.22231C86.6426 2.01863 87.7003 3.15772 88.3981 4.5149C89.0959 5.87209 89.4069 7.39509 89.2971 8.91719C89.1873 10.4393 88.6609 11.9019 87.7755 13.1448L72.6258 34.4061C71.3979 36.1306 69.7755 37.5366 67.894 38.5069C66.0124 39.4772 63.9262 39.9837 61.8092 39.9842Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_305_737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.86302 0H-0.0117188V39.9842H4.86302V0Z",
    fill: "#2B5C7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7302 0H4.85547V39.9842H9.7302V0Z",
    fill: "#2A5C7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6052 0H9.73047V39.9842H14.6052V0Z",
    fill: "#295D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4802 0H14.6055V39.9842H19.4802V0Z",
    fill: "#285D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3474 0H19.4727V39.9842H24.3474V0Z",
    fill: "#275D7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2224 0H24.3477V39.9842H29.2224V0Z",
    fill: "#265E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0974 0H29.2227V39.9842H34.0974V0Z",
    fill: "#255E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9646 0H34.0898V39.9842H38.9646V0Z",
    fill: "#235E7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8396 0H38.9648V39.9842H43.8396V0Z",
    fill: "#225F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7029 0H43.8281V39.9842H48.7029V0Z",
    fill: "#215F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5779 0H48.7031V39.9842H53.5779V0Z",
    fill: "#205F7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4529 0H53.5781V39.9842H58.4529V0Z",
    fill: "#1F607A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3201 0H58.4453V39.9842H63.3201V0Z",
    fill: "#1E607A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6113 0H63.3203V39.9842H63.6113V0Z",
    fill: "#1E607A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9043 0H63.6133V39.9842H63.9043V0Z",
    fill: "#1E617B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1934 0H63.9023V39.9842H64.1934V0Z",
    fill: "#1F627C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4746 0H64.1836V39.9842H64.4746V0Z",
    fill: "#1F637D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7676 0H64.4766V39.9842H64.7676V0Z",
    fill: "#20647E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0567 0H64.7656V39.9842H65.0567V0Z",
    fill: "#20647F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3496 0H65.0586V39.9842H65.3496V0Z",
    fill: "#216580"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6309 0H65.3398V39.9842H65.6309V0Z",
    fill: "#216681"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9238 0H65.6328V39.9842H65.9238V0Z",
    fill: "#216782"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2129 0H65.9219V39.9842H66.2129V0Z",
    fill: "#226883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5059 0H66.2148V39.9842H66.5059V0Z",
    fill: "#226984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7871 0H66.4961V39.9842H66.7871V0Z",
    fill: "#236A85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0801 0H66.7891V39.9842H67.0801V0Z",
    fill: "#236B86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3692 0H67.0781V39.9842H67.3692V0Z",
    fill: "#246B87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6543 0H67.3633V39.9842H67.6543V0Z",
    fill: "#246C88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9434 0H67.6523V39.9842H67.9434V0Z",
    fill: "#246D89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.2363 0H67.9453V39.9842H68.2363V0Z",
    fill: "#256E8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5254 0H68.2344V39.9842H68.5254V0Z",
    fill: "#256F8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8106 0H68.5195V39.9842H68.8106V0Z",
    fill: "#26708C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0996 0H68.8086V39.9842H69.0996V0Z",
    fill: "#26718D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3926 0H69.1016V39.9842H69.3926V0Z",
    fill: "#27728E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6817 0H69.3906V39.9842H69.6817V0Z",
    fill: "#27728F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9668 0H69.6758V39.9842H69.9668V0Z",
    fill: "#277390"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2559 0H69.9648V39.9842H70.2559V0Z",
    fill: "#287491"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5488 0H70.2578V39.9842H70.5488V0Z",
    fill: "#287592"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8379 0H70.5469V39.9842H70.8379V0Z",
    fill: "#297693"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1231 0H70.832V39.9842H71.1231V0Z",
    fill: "#297794"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4121 0H71.1211V39.9842H71.4121V0Z",
    fill: "#2A7895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7051 0H71.4141V39.9842H71.7051V0Z",
    fill: "#2A7996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9941 0H71.7031V39.9842H71.9941V0Z",
    fill: "#2A7997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2793 0H71.9883V39.9842H72.2793V0Z",
    fill: "#2B7A98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5684 0H72.2773V39.9842H72.5684V0Z",
    fill: "#2B7B99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8613 0H72.5703V39.9842H72.8613V0Z",
    fill: "#2C7C9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1504 0H72.8594V39.9842H73.1504V0Z",
    fill: "#2C7D9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4356 0H73.1445V39.9842H73.4356V0Z",
    fill: "#2D7E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7246 0H73.4336V39.9842H73.7246V0Z",
    fill: "#2D7F9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0176 0H73.7266V39.9842H74.0176V0Z",
    fill: "#2D809E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3067 0H74.0156V39.9842H74.3067V0Z",
    fill: "#2E809F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5879 0H74.2969V39.9842H74.5879V0Z",
    fill: "#2E81A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8809 0H74.5898V39.9842H74.8809V0Z",
    fill: "#2F82A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1699 0H74.8789V39.9842H75.1699V0Z",
    fill: "#2F83A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4629 0H75.1719V39.9842H75.4629V0Z",
    fill: "#3084A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7442 0H75.4531V39.9842H75.7442V0Z",
    fill: "#3085A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0371 0H75.7461V39.9842H76.0371V0Z",
    fill: "#3086A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3262 0H76.0352V39.9842H76.3262V0Z",
    fill: "#3187A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6192 0H76.3281V39.9842H76.6192V0Z",
    fill: "#3187A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9004 0H76.6094V39.9842H76.9004V0Z",
    fill: "#3288A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1934 0H76.9023V39.9842H77.1934V0Z",
    fill: "#3289AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4824 0H77.1914V39.9842H77.4824V0Z",
    fill: "#328AAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7754 0H77.4844V39.9842H77.7754V0Z",
    fill: "#338BAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0566 0H77.7656V39.9842H78.0566V0Z",
    fill: "#338CAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3496 0H78.0586V39.9842H78.3496V0Z",
    fill: "#348DAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6387 0H78.3477V39.9842H78.6387V0Z",
    fill: "#348EAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9317 0H78.6406V39.9842H78.9317V0Z",
    fill: "#358EB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2129 0H78.9219V39.9842H79.2129V0Z",
    fill: "#358FB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5059 0H79.2148V39.9842H79.5059V0Z",
    fill: "#3590B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7949 0H79.5039V39.9842H79.7949V0Z",
    fill: "#3691B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0879 0H79.7969V39.9842H80.0879V0Z",
    fill: "#3692B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3692 0H80.0781V39.9842H80.3692V0Z",
    fill: "#3793B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6621 0H80.3711V39.9842H80.6621V0Z",
    fill: "#3794B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9512 0H80.6602V39.9842H80.9512V0Z",
    fill: "#3895B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2442 0H80.9531V39.9842H81.2442V0Z",
    fill: "#3895B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5254 0H81.2344V39.9842H81.5254V0Z",
    fill: "#3896B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8184 0H81.5273V39.9842H81.8184V0Z",
    fill: "#3997BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1074 0H81.8164V39.9842H82.1074V0Z",
    fill: "#3998BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4004 0H82.1094V39.9842H82.4004V0Z",
    fill: "#3A99BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6817 0H82.3906V39.9842H82.6817V0Z",
    fill: "#3A9ABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9746 0H82.6836V39.9842H82.9746V0Z",
    fill: "#3B9BBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2637 0H82.9727V39.9842H83.2637V0Z",
    fill: "#3B9CBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5567 0H83.2656V39.9842H83.5567V0Z",
    fill: "#3B9CC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8379 0H83.5469V39.9842H83.8379V0Z",
    fill: "#3C9DC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1309 0H83.8398V39.9842H84.1309V0Z",
    fill: "#3C9EC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4199 0H84.1289V39.9842H84.4199V0Z",
    fill: "#3D9FC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7129 0H84.4219V39.9842H84.7129V0Z",
    fill: "#3DA0C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9942 0H84.7031V39.9842H84.9942V0Z",
    fill: "#3EA1C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2832 0H84.9922V39.9842H85.2832V0Z",
    fill: "#3EA2C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5762 0H85.2852V39.9842H85.5762V0Z",
    fill: "#3EA3C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8652 0H85.5742V39.9842H85.8652V0Z",
    fill: "#3FA3C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1504 0H85.8594V39.9842H86.1504V0Z",
    fill: "#3FA4C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4395 0H86.1484V39.9842H86.4395V0Z",
    fill: "#40A5CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7324 0H86.4414V39.9842H86.7324V0Z",
    fill: "#40A6CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0137 0H86.7227V39.9842H87.0137V0Z",
    fill: "#41A7CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3067 0H87.0156V39.9842H87.3067V0Z",
    fill: "#41A8CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5957 0H87.3047V39.9842H87.5957V0Z",
    fill: "#41A9CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8887 0H87.5977V39.9842H87.8887V0Z",
    fill: "#42AACF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1699 0H87.8789V39.9842H88.1699V0Z",
    fill: "#42AAD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4629 0H88.1719V39.9842H88.4629V0Z",
    fill: "#43ABD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.752 0H88.4609V39.9842H88.752V0Z",
    fill: "#43ACD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0449 0H88.7539V39.9842H89.0449V0Z",
    fill: "#44ADD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3262 0H89.0352V39.9842H89.3262V0Z",
    fill: "#44AED4"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_305_737",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 86
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8453 62.2641L38.892 82.5391C38.0981 83.6922 37.0041 84.6063 35.7283 85.1826C34.4524 85.759 33.0434 85.9756 31.6533 85.8091C30.2633 85.6427 28.9452 85.0994 27.8416 84.2381C26.7379 83.3768 25.8907 82.2302 25.3915 80.9223L0.775283 16.904C0.0846532 15.0185 -0.144587 12.9952 0.106733 11.003C0.358053 9.01089 1.08263 7.10779 2.21988 5.453C3.35713 3.79816 4.87401 2.43963 6.64371 1.49096C8.4134 0.54229 10.3845 0.03106 12.3922 0H56.7661C54.4188 0.43688 52.1161 1.08628 49.8865 1.9402C44.3973 4.15525 41.6164 11.1319 43.6293 16.7261L54.737 47.6641C55.5997 50.0737 55.8781 52.6537 55.5492 55.1919C55.2204 57.7301 54.2936 60.154 52.8453 62.2641Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_305_737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 0H-2.22266V2.43333H56.7916V0Z",
    fill: "#53A1D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 2.43359H-2.22266V4.86691H56.7916V2.43359Z",
    fill: "#53A2D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 4.86719H-2.22266V7.30049H56.7916V4.86719Z",
    fill: "#52A3DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 7.30859H-2.22266V9.74189H56.7916V7.30859Z",
    fill: "#52A4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 9.74219H-2.22266V12.1755H56.7916V9.74219Z",
    fill: "#52A5DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 12.1758H-2.22266V14.6091H56.7916V12.1758Z",
    fill: "#52A6DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 14.6094H-2.22266V17.0427H56.7916V14.6094Z",
    fill: "#51A7DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 17.043H-2.22266V19.4763H56.7916V17.043Z",
    fill: "#51A8DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 19.4766H-2.22266V21.9099H56.7916V19.4766Z",
    fill: "#51A9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 21.918H-2.22266V24.3513H56.7916V21.918Z",
    fill: "#50AADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 24.3477H-2.22266V26.781H56.7916V24.3477Z",
    fill: "#50ABE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 26.7812H-2.22266V29.2146H56.7916V26.7812Z",
    fill: "#50ACE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 29.2148H-2.22266V31.6481H56.7916V29.2148Z",
    fill: "#50AEE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 31.6484H-2.22266V34.0818H56.7916V31.6484Z",
    fill: "#4FAFE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 34.082H-2.22266V36.5154H56.7916V34.082Z",
    fill: "#4FB0E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 36.5234H-2.22266V38.9568H56.7916V36.5234Z",
    fill: "#4FB1E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 38.957H-2.22266V41.3904H56.7916V38.957Z",
    fill: "#4EB2E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 41.3906H-2.22266V43.824H56.7916V41.3906Z",
    fill: "#4EB3E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 43.8242H-2.22266V46.2576H56.7916V43.8242Z",
    fill: "#4EB4E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 46.2578H-2.22266V48.6912H56.7916V46.2578Z",
    fill: "#4DB5E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 48.6992H-2.22266V51.1326H56.7916V48.6992Z",
    fill: "#4DB6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 51.1328H-2.22266V53.5662H56.7916V51.1328Z",
    fill: "#4DB7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 53.5664H-2.22266V55.9997H56.7916V53.5664Z",
    fill: "#4DB8E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 56H-2.22266V58.4333H56.7916V56Z",
    fill: "#4CB9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 58.4336H-2.22266V60.8669H56.7916V58.4336Z",
    fill: "#4CBAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 60.8672H-2.22266V61.1421H56.7916V60.8672Z",
    fill: "#4CBAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 61.1406H-2.22266V61.4155H56.7916V61.1406Z",
    fill: "#4DBAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 61.4141H-2.22266V61.6889H56.7916V61.4141Z",
    fill: "#4EBAE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 61.6914H-2.22266V61.9663H56.7916V61.6914Z",
    fill: "#4FBAE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 61.9648H-2.22266V62.2396H56.7916V61.9648Z",
    fill: "#50BBE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 62.2383H-2.22266V62.5132H56.7916V62.2383Z",
    fill: "#51BBE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 62.5156H-2.22266V62.7905H56.7916V62.5156Z",
    fill: "#52BBE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 62.7891H-2.22266V63.0639H56.7916V62.7891Z",
    fill: "#53BBE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 63.0625H-2.22266V63.3374H56.7916V63.0625Z",
    fill: "#54BBE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 63.3398H-2.22266V63.6146H56.7916V63.3398Z",
    fill: "#55BBE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 63.6133H-2.22266V63.8882H56.7916V63.6133Z",
    fill: "#56BCE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 63.8906H-2.22266V64.1655H56.7916V63.8906Z",
    fill: "#57BCE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 64.1641H-2.22266V64.4389H56.7916V64.1641Z",
    fill: "#58BCE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 64.4375H-2.22266V64.7124H56.7916V64.4375Z",
    fill: "#59BCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 64.7148H-2.22266V64.9896H56.7916V64.7148Z",
    fill: "#5ABCDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 64.9883H-2.22266V65.2632H56.7916V64.9883Z",
    fill: "#5BBCDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 65.2617H-2.22266V65.5366H56.7916V65.2617Z",
    fill: "#5CBCDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 65.5391H-2.22266V65.8139H56.7916V65.5391Z",
    fill: "#5DBDDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 65.8125H-2.22266V66.0874H56.7916V65.8125Z",
    fill: "#5EBDDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 66.0859H-2.22266V66.3607H56.7916V66.0859Z",
    fill: "#5FBDDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 66.3633H-2.22266V66.6382H56.7916V66.3633Z",
    fill: "#60BDDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 66.6367H-2.22266V66.9116H56.7916V66.6367Z",
    fill: "#61BDD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 66.9141H-2.22266V67.1889H56.7916V66.9141Z",
    fill: "#62BDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 67.1875H-2.22266V67.4624H56.7916V67.1875Z",
    fill: "#63BED7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 67.4609H-2.22266V67.7357H56.7916V67.4609Z",
    fill: "#64BED6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 67.7383H-2.22266V68.0132H56.7916V67.7383Z",
    fill: "#65BED5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 68.0117H-2.22266V68.2866H56.7916V68.0117Z",
    fill: "#66BED4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 68.2852H-2.22266V68.56H56.7916V68.2852Z",
    fill: "#67BED4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 68.5625H-2.22266V68.8374H56.7916V68.5625Z",
    fill: "#68BED3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 68.8359H-2.22266V69.1107H56.7916V68.8359Z",
    fill: "#69BFD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 69.1133H-2.22266V69.3882H56.7916V69.1133Z",
    fill: "#6ABFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 69.3867H-2.22266V69.6616H56.7916V69.3867Z",
    fill: "#6BBFD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 69.6602H-2.22266V69.935H56.7916V69.6602Z",
    fill: "#6CBFCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 69.9375H-2.22266V70.2124H56.7916V69.9375Z",
    fill: "#6DBFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 70.2109H-2.22266V70.4857H56.7916V70.2109Z",
    fill: "#6EBFCE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 70.4844H-2.22266V70.7592H56.7916V70.4844Z",
    fill: "#6FBFCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 70.7617H-2.22266V71.0366H56.7916V70.7617Z",
    fill: "#70C0CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 71.0352H-2.22266V71.31H56.7916V71.0352Z",
    fill: "#71C0CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 71.3086H-2.22266V71.5835H56.7916V71.3086Z",
    fill: "#72C0CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 71.5859H-2.22266V71.8607H56.7916V71.5859Z",
    fill: "#73C0C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 71.8594H-2.22266V72.1343H56.7916V71.8594Z",
    fill: "#74C0C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 72.1367H-2.22266V72.4116H56.7916V72.1367Z",
    fill: "#75C0C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 72.4102H-2.22266V72.685H56.7916V72.4102Z",
    fill: "#76C1C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 72.6758H-2.22266V72.9507H56.7916V72.6758Z",
    fill: "#77C1C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 72.9531H-2.22266V73.228H56.7916V72.9531Z",
    fill: "#78C1C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 73.2266H-2.22266V73.5014H56.7916V73.2266Z",
    fill: "#7AC1C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 73.5H-2.22266V73.7749H56.7916V73.5Z",
    fill: "#7BC1C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 73.7773H-2.22266V74.0521H56.7916V73.7773Z",
    fill: "#7CC1C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 74.0508H-2.22266V74.3257H56.7916V74.0508Z",
    fill: "#7DC1C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 74.3242H-2.22266V74.5991H56.7916V74.3242Z",
    fill: "#7EC2C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 74.6016H-2.22266V74.8764H56.7916V74.6016Z",
    fill: "#7FC2C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 74.875H-2.22266V75.1499H56.7916V74.875Z",
    fill: "#80C2BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 75.1484H-2.22266V75.4233H56.7916V75.1484Z",
    fill: "#81C2BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 75.4258H-2.22266V75.7007H56.7916V75.4258Z",
    fill: "#82C2BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 75.6992H-2.22266V75.9741H56.7916V75.6992Z",
    fill: "#83C2BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 75.9766H-2.22266V76.2514H56.7916V75.9766Z",
    fill: "#84C3BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 76.25H-2.22266V76.5249H56.7916V76.25Z",
    fill: "#85C3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 76.5234H-2.22266V76.7983H56.7916V76.5234Z",
    fill: "#86C3BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 76.8008H-2.22266V77.0757H56.7916V76.8008Z",
    fill: "#87C3B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 77.0742H-2.22266V77.3491H56.7916V77.0742Z",
    fill: "#88C3B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 77.3477H-2.22266V77.6225H56.7916V77.3477Z",
    fill: "#89C3B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 77.625H-2.22266V77.8999H56.7916V77.625Z",
    fill: "#8AC3B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 77.8984H-2.22266V78.1733H56.7916V77.8984Z",
    fill: "#8BC4B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 78.1719H-2.22266V78.4467H56.7916V78.1719Z",
    fill: "#8CC4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 78.4492H-2.22266V78.7241H56.7916V78.4492Z",
    fill: "#8DC4B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 78.7227H-2.22266V78.9975H56.7916V78.7227Z",
    fill: "#8EC4B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 79H-2.22266V79.2749H56.7916V79Z",
    fill: "#8FC4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 79.2734H-2.22266V79.5483H56.7916V79.2734Z",
    fill: "#90C4B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 79.5469H-2.22266V79.8218H56.7916V79.5469Z",
    fill: "#91C5B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 79.8242H-2.22266V80.0991H56.7916V79.8242Z",
    fill: "#92C5AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 80.0977H-2.22266V80.3725H56.7916V80.0977Z",
    fill: "#93C5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 80.3711H-2.22266V80.646H56.7916V80.3711Z",
    fill: "#94C5AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 80.6484H-2.22266V80.9233H56.7916V80.6484Z",
    fill: "#95C5AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 80.9219H-2.22266V81.1968H56.7916V80.9219Z",
    fill: "#96C5AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 81.1953H-2.22266V81.4702H56.7916V81.1953Z",
    fill: "#97C6AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 81.4727H-2.22266V81.7475H56.7916V81.4727Z",
    fill: "#98C6AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 81.7461H-2.22266V82.021H56.7916V81.7461Z",
    fill: "#99C6A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 82.0234H-2.22266V82.2983H56.7916V82.0234Z",
    fill: "#9AC6A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 82.2969H-2.22266V82.5717H56.7916V82.2969Z",
    fill: "#9BC6A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 82.5703H-2.22266V82.8452H56.7916V82.5703Z",
    fill: "#9CC6A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 82.8477H-2.22266V83.1225H56.7916V82.8477Z",
    fill: "#9DC6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 83.1211H-2.22266V83.396H56.7916V83.1211Z",
    fill: "#9EC7A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 83.3945H-2.22266V83.6694H56.7916V83.3945Z",
    fill: "#9FC7A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 83.6719H-2.22266V83.9468H56.7916V83.6719Z",
    fill: "#A0C7A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 83.9453H-2.22266V84.2202H56.7916V83.9453Z",
    fill: "#A1C7A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 84.2188H-2.22266V84.4936H56.7916V84.2188Z",
    fill: "#A2C7A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 84.4961H-2.22266V84.771H56.7916V84.4961Z",
    fill: "#A3C7A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 84.7695H-2.22266V85.0444H56.7916V84.7695Z",
    fill: "#A4C8A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 85.0391H-2.22266V85.3139H56.7916V85.0391Z",
    fill: "#A5C89F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 85.3125H-2.22266V85.5874H56.7916V85.3125Z",
    fill: "#A6C89E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7916 85.5859H-2.22266V85.8607H56.7916V85.5859Z",
    fill: "#A7C89D"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8024 19.6438C64.5259 19.6438 66.7338 17.4361 66.7338 14.7126C66.7338 11.9891 64.5259 9.78125 61.8024 9.78125C59.0789 9.78125 56.8711 11.9891 56.8711 14.7126C56.8711 17.4361 59.0789 19.6438 61.8024 19.6438Z",
    fill: "#E9E9E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/brand.c4b59a6333e2dfbd07a334b9f3a1be55.svg";
export { ForwardRef as ReactComponent };